const supportedDecks = ['upperDeck', 'mainDeck', 'lowerDeck'];
const checkForCabins = val => {
  const isCabinsFound = val && typeof val === 'object' && 'cabins' in val;
  const cabins = isCabinsFound ? val.cabins : [];
  return cabins.length > 0;
};
const filterDeckType = decks => _ref => {
  let [key, val] = _ref;
  const hasCabins = checkForCabins(val);
  return decks.some(deck => deck === key.toString() && hasCabins);
};
export const getAvailableDecksForSegment = segment => segment ? Object.entries(segment).filter(filterDeckType(supportedDecks)).map(_ref2 => {
  let [key] = _ref2;
  return key;
}) : [];
const getOptionLabel = (deck, upperDeckLabel, mainDeckLabel, lowerDeckLabel) => {
  switch (deck) {
    case 'upperDeck':
      return upperDeckLabel;
    case 'lowerDeck':
      return lowerDeckLabel;
    default:
      return mainDeckLabel;
  }
};
export const getAvailableDeckOptions = (segment, upperDeckLabel, mainDeckLabel, lowerDeckLabel) => segment && mainDeckLabel && lowerDeckLabel && upperDeckLabel ? getAvailableDecksForSegment(segment).map(deck => ({
  label: getOptionLabel(deck, upperDeckLabel, mainDeckLabel, lowerDeckLabel),
  value: deck
})) : [];
export const getCabins = (segment, selectedDeck) => {
  return selectedDeck && segment && segment[selectedDeck.value] ? segment[selectedDeck.value].cabins : [];
};
//# sourceMappingURL=decks.js.map